import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FindWorkSection } from './components/FindWorkSection';
import { ExploreOpportunities } from './components/ExploreOpportunities';
import { EmployerSolutions } from './components/EmployerSolutions';
import { WorkforcePartner } from './components/WorkforcePartner';
import { NextStep } from './components/NextStep';
import { GulfCoastExpertise } from './components/GulfCoastExpertise';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://talentprism.ai/static/js/chat-widget-loader-bundle.js';
    script.setAttribute('data-team-id', '3571');
    script.setAttribute('data-token', 'dgOQNElFKIKhuIHK8q_WcyvOvvs5xnU9r2h59142BS4');
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-0">
      {/* Demo Banner */}
      <div className="bg-primary text-white text-center py-3 px-4 font-heading font-semibold tracking-wide text-sm" data-id="element-1">
        🚀 THIS IS A DEMO PAGE TO SHOWCASE THE TALENTPRISM CHAT WIDGET FOR BLAKE
        BOWIE
      </div>
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <FindWorkSection data-id="element-5" />
        <ExploreOpportunities data-id="element-6" />
        <EmployerSolutions data-id="element-7" />
        <WorkforcePartner data-id="element-8" />
        <NextStep data-id="element-9" />
        <GulfCoastExpertise data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}